import { Component, Input, OnInit } from '@angular/core';

import { SharedAnalyticsService } from '../../analytics/shared-analytics/shared-analytics.service';
import { EAnalyticsPageViews } from '../../enums/analytics.enum';
import { SECTIONS } from '../../models/Constants';
import { IErrorScreen } from '../../models/Error';

@Component({
  selector: 'app-empty-data',
  templateUrl: './empty-data.component.html',
  styleUrls: ['./empty-data.component.scss'],
})
export class EmptyDataComponent implements OnInit {

  @Input() tipoError: IErrorScreen | null = null;

  constructor(
    private sharedAnalyticsS: SharedAnalyticsService
  ) { }

  ngOnInit() {
    if (this.tipoError) {
      this.sharedAnalyticsS.trackPageView(EAnalyticsPageViews[this.tipoError.analyticScreen as keyof typeof EAnalyticsPageViews], SECTIONS.EMPTY);
    }
  }

}
